import styled, { css } from 'styled-components';

import { iconFill, mediaQuery } from '../../styles/mixin';
import { InputStyle } from '../FormInput/styled';
import { Icon } from '../Icon';

interface ICommonProps {
    isFocused: boolean;
    disableShrinking?: boolean;
}

export const StyledIcon = styled(Icon)<ICommonProps>`
    position: absolute;
    top: 50%;
    left: 0.625rem;
    width: 1rem;
    height: 1rem;
    ${({ theme, isFocused }) =>
        iconFill(
            isFocused ? theme.colors.bgSecondary : theme.colors.fontSearch
        )}
    transform: translateY(-50%);
    transition: all ${({ theme }) => theme.transitions.hover};
    pointer-events: none;
`;

interface IInputProps extends ICommonProps {
    dimmed?: boolean;
    hasError: false;
}

export const Input = styled.input.attrs({ hasError: false })<IInputProps>`
    width: 100%;
    ${InputStyle}
    appearance: none;
    transition: all ${({ theme }) => theme.transitions.hover};
    background-color: ${({ dimmed, theme }) =>
        dimmed && theme.colors.lightShadow};
    padding: 0.25rem 1rem 0.25rem 2rem;
    padding-left: ${({ isFocused, disableShrinking }) =>
        !disableShrinking && !isFocused && '1.125rem'};
    padding-right: ${({ isFocused, disableShrinking }) =>
        !disableShrinking && !isFocused && '1.125rem'};

    &::placeholder {
        opacity: ${({ disableShrinking }) => !disableShrinking && '0'};
    }

    &::-webkit-search-cancel-button {
        display: none;
        cursor: pointer;
    }

    ${mediaQuery(
        2,
        css`
            padding: 0.25rem 1rem 0.25rem 2rem;
            color: ${({ theme }) => theme.colors.fontSearch};

            &::placeholder {
                opacity: 1;
            }

            &::-webkit-search-cancel-button {
                display: initial;
            }
        `
    )}

    &:focus {
        color: ${({ theme }) => theme.colors.fontPrimary};
        padding: 0.25rem 1rem 0.25rem 2rem;

        &::-webkit-search-cancel-button {
            display: initial;
        }
    }
`;

export const Container = styled.div<ICommonProps>`
    position: relative;
    font-size: ${({ theme }) => theme.fontSizes[4]};
    height: min-content;
    ${mediaQuery(
        2,
        css`
            width: 19.5rem;
            max-width: 100%;
        `
    )}

    transition: all ${({ theme }) => theme.transitions.hover};
    width: ${({ isFocused, disableShrinking }) =>
        !disableShrinking && (isFocused ? '9rem' : '2.25rem')};
`;
